import React from 'react';
import withUser from '../auth/withUser';
import NavUser from './NavUser';
import NavAdminMenu from './NavAdminMenu';
import NavMarketingMenu from './NavMarketingMenu';
import NavLogo from './NavLogo';
import NavMenu from './NavMenu';
import { get as _get } from 'lodash';

class Nav extends React.Component {
  render() {
    const isAdmin = _get(this, 'props.user.role', '') === "admin"
    return (
      <div className={"nav__wrap" + (isAdmin ? ' admin-wrapper' : '')}>
        <nav className="nav">
          <NavMenu
            Component={this.menuSwitch(this.props.user.role || '')}
            windowWidth={this.props.windowWidth}
            isLoggedIn={this.props.isLoggedIn()}
            logout={this.props.logout}
            clientStyleVariation={this.props.clientStyleVariation}
          />
          <NavLogo />
          <NavUser
            isLoggedIn={this.props.isLoggedIn()}
            logout={this.props.logout}
            clientStyleVariation={this.props.clientStyleVariation}
          />
        </nav>
      </div>
    );
  }

  menuSwitch = type =>
    ({
      admin: NavAdminMenu,
      client: NavMarketingMenu,
      chef: NavMarketingMenu
    }[type] || NavMarketingMenu);
}

export default withUser(Nav);



// WEBPACK FOOTER //
// ./src/components/nav/Nav.js